import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss']
})
export class PaginatorComponent implements OnInit {

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  currentPage: number = 0;
  pageSize: number = 10;
  totalRows: number;

  constructor() { }

  ngOnInit(): void {
  }

  pageChanged(event: PageEvent): void {
    this.pageSize = event.pageSize;
    if (event.pageIndex === 0) {
      this.currentPage = 0;
    } else {
      this.currentPage = event.pageIndex;
    }
  }

}
